import { Link } from "react-router-dom";
import { Linkedin, Twitter } from "lucide-react";
import { LeaseFlowMark } from "@/components/Logo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#040A14] border-t border-white/10 mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <Link to="/" className="flex items-center gap-2.5">
            <LeaseFlowMark size={32} />
            <span className="font-display text-[19px] font-semibold tracking-tight text-white">
              Lease<span style={{ color: "#00D4AA" }}>Flow</span>
            </span>
          </Link>
          <p className="mt-4 text-sm text-slate-400 max-w-xs leading-relaxed">
            Visual case management for UK conveyancing and leasehold law firms. Reduce emails. Increase clarity.
          </p>
          <div className="mt-5 flex gap-3 text-slate-500">
            <a href="#" className="hover:text-white" aria-label="LinkedIn"><Linkedin size={16} /></a>
            <a href="#" className="hover:text-white" aria-label="Twitter"><Twitter size={16} /></a>
          </div>
        </div>

        <div>
          <p className="overline mb-4">Product</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/features" className="text-slate-400 hover:text-white">Features</Link></li>
            <li><Link to="/how-it-works" className="text-slate-400 hover:text-white">How it works</Link></li>
            <li><Link to="/use-cases" className="text-slate-400 hover:text-white">Use cases</Link></li>
            <li><Link to="/customers" className="text-slate-400 hover:text-white">Customers</Link></li>
            <li><Link to="/pricing" className="text-slate-400 hover:text-white">Pricing</Link></li>
          </ul>
        </div>

        <div>
          <p className="overline mb-4">Resources</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/glossary" className="text-slate-400 hover:text-white">UK Glossary</Link></li>
            <li><Link to="/timeline" className="text-slate-400 hover:text-white">Case Timeline</Link></li>
            <li><Link to="/about" className="text-slate-400 hover:text-white">About</Link></li>
            <li><Link to="/demo" className="text-slate-400 hover:text-white">Book a demo</Link></li>
          </ul>
        </div>

        <div>
          <p className="overline mb-4">Legal</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/legal" className="text-slate-400 hover:text-white">Disclaimer</Link></li>
            <li><Link to="/privacy" className="text-slate-400 hover:text-white">Privacy</Link></li>
            <li><Link to="/terms" className="text-slate-400 hover:text-white">Terms</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs text-slate-500 font-mono">© {new Date().getFullYear()} LeaseFlow Ltd · England &amp; Wales</p>
          <p className="text-xs text-slate-500 font-mono">Software-only. Not a law firm. Not FCA-authorised.</p>
        </div>
      </div>
    </footer>
  );
}
